import styled from "styled-components";
import { Button } from "react-bootstrap";

export const CancelButton = styled(Button)`
  color: white;
  background: ${props => props.theme.colors.borderColor};
  margin-right: 15px;
`;